import axios from 'axios';

// En producción, el backend vive en el mismo dominio bajo /api (proxy de Passenger/Apache).
// En desarrollo local, apunta al puerto del backend.
const baseURL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL,
  withCredentials: true // envía/recibe la cookie httpOnly del JWT
});

// Inserta automáticamente la empresa activa (guardada en localStorage) en cada petición
api.interceptors.request.use((config) => {
  const empresaId = localStorage.getItem('empresaActivaId');
  if (empresaId) {
    config.headers['X-Empresa-Id'] = empresaId;
  }
  // Sub-identidad de cajero para el Módulo Caja / POS (pendiente #91).
  const cajeroToken = localStorage.getItem('cajaCajeroToken');
  if (cajeroToken) {
    config.headers['X-Cajero-Token'] = cajeroToken;
  }
  return config;
});

// Si el token expiró, redirige a login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('empresaActivaId');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
